var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{":key":_vm.index}},[_c('list-more',{attrs:{"publicationsData":_vm.morePublications[_vm.index],"bo":_vm.bo},on:{"progressmore":_vm.onChangeLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }